import React from 'react';
import { skillsArray } from '../../data';
import {
	Heading,
	ParagraphText,
	SillImage,
	SkillImageContainer,
	SkillsContainer,
	SkillsItem,
	SkillsList,
} from '../../styles';
import { AppWrap, MotionWrap } from '../../wrapper';
const Skills = () => {
	return (
		<>
			<Heading>
				My <span>Skills</span>
			</Heading>

			<SkillsContainer>
				<SkillsList>
					{skillsArray.map((skill) => (
						<SkillsItem
							whileInView={{ opacity: [0, 1] }}
							transition={{ duration: 0.5 }}
							key={skill.id}
						>
							<SkillImageContainer>
								<SillImage src={skill.icon} alt={skill.name} />
							</SkillImageContainer>
							<ParagraphText>{skill.name}</ParagraphText>
						</SkillsItem>
					))}
				</SkillsList>
			</SkillsContainer>
		</>
	);
};

export default AppWrap(MotionWrap(Skills), 'Skills', 'app__whitebg');
